import styled from 'styled-components'

export const Empty = styled.div`
	background-color: ${({ theme }) => theme.color.input.background};
	color: ${({ theme }) => theme.color.input.textHint};
	text-align: center;
	padding: 12px;
	border-radius: 4px;
`
